import { PatchUserPayload } from 'types/user';
import { usersApi } from 'apis/CompanyAPI/users/usersApi';
import { invalidate } from 'hooks/useSWR';
import { selfDetailedKey } from 'apis/CompanyAPI/users/useSelfUserProfile';
import { useUserProfilesInvalidate } from 'apis/CompanyAPI/users/useUserProfiles';

import { companiesAPIUrls } from 'apis/CompanyAPI/companies/companiesApi';
import useLazyResource from 'util/resource/useLazyResource';

export async function saveUser(user: PatchUserPayload) {
  const industryInvestmentPreferences = user.industryInvestmentPreferences?.filter(it => it != null);
  const response = await usersApi.userProfiles.patchProfile({
    ...user,
    industryInvestmentPreferences,
  });
  invalidate(selfDetailedKey, response);
  invalidate(companiesAPIUrls.getPublicProfilesSuggestedForOnboarding());
}
export function useSaveUser(onSuccess?: () => void) {
  const invalidateProfiles = useUserProfilesInvalidate();

  const [saveUser, isSaving] = useLazyResource(
    (user: PatchUserPayload) => {
      const industryInvestmentPreferences = user.industryInvestmentPreferences?.filter(it => it != null);
      return usersApi.userProfiles.patchProfile({
        ...user,
        industryInvestmentPreferences,
      });
    },
    {
      onSuccess: response => {
        onSuccess?.();
        invalidate(selfDetailedKey, response);
        invalidate(companiesAPIUrls.getPublicProfilesSuggestedForOnboarding());
        // Invalidate the userProfiles cache for this user
        invalidateProfiles([response.cwUserId]);
      },
    },
  );
  return { saveUser, isSaving };
}
